export default {
    // Home page
    home: {
        title: 'Timer.today • सर्वश्रेष्ठ ऑनलाइन टाइमर, स्टॉपवॉच और विश्व घड़ी',
        description: '⏰ मुफ्त ऑनलाइन टाइमिंग उपकरण जिनमें काउंटडाउन टाइमर, सटीक स्टॉपवॉच और विश्व घड़ी शामिल है। उत्पादकता, खाना पकाने, पढ़ाई, खेल प्रशिक्षण और समय क्षेत्र प्रबंधन के लिए आदर्श। कोई विज्ञापन नहीं।',
        keywords: ['ऑनलाइन टाइमर', 'काउंटडाउन टाइमर', 'ऑनलाइन स्टॉपवॉच', 'विश्व घड़ी', 'उत्पादकता टाइमर', 'पोमोडोरो टाइमर', 'खाना पकाने का टाइमर', 'मुफ्त टाइमर टूल', 'ब्राउजर टाइमर', 'समय प्रबंधन'],
        ogTitle: 'व्यावहारिक ऑनलाइन टाइमर उपकरण - timer.today',
        ogDescription: 'व्यावहारिक ऑनलाइन टाइमिंग टूल प्लेटफॉर्म जो काउंटडाउन टाइमर, स्टॉपवॉच और विश्व घड़ी सुविधाएं प्रदान करता है',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Timer.Today",
            "description": "मुफ्त ऑनलाइन टाइमिंग उपकरण जिनमें काउंटडाउन टाइमर, सटीक स्टॉपवॉच और विश्व घड़ी शामिल है। उत्पादकता, खाना पकाने, पढ़ाई, खेल प्रशिक्षण और समय क्षेत्र प्रबंधन के लिए आदर्श। कोई विज्ञापन नहीं।",
            "url": "https://timer.today",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "ऑनलाइन टाइमर",
                "ध्वनि सतर्कता",
                "कई टाइमर पूर्वनिर्धारित",
                "स्टॉपवॉच",
                "विश्व घड़ी"
            ],
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "503"
            }
        }
    },

    // Timer page
    timer: {
        // मुख्य SEO टैग अनुकूलन
        title: 'ऑनलाइन टाइमर • ध्वनि सतर्कता के साथ मुफ्त काउंटडाउन टूल',
        description: '⏰ ऑनलाइन काउंटडाउन टाइमर कस्टम सेटिंग्स के साथ। पोमोडोरो, अध्ययन, काम ब्रेक के लिए त्वरित 10मिन/15मिन प्रारंभ करें। मुफ्त + ध्वनि सतर्कता 🔔!',

        // कीवर्ड अनुकूलन
        keywords: [
            '10 मिनट टाइमर', '15 मिनट टाइमर', '30 मिनट टाइमर',
            'पोमोडोरो टाइमर', 'अध्ययन टाइमर', 'काम ब्रेक टाइमर',
            'ध्वनि सतर्कता के साथ टाइमर', 'ऑनलाइन काउंटडाउन टूल',
            'उत्पादकता टाइमर', 'समय प्रबंधन टूल'
        ],

        // सोशल मीडिया SEO अनुकूलन
        ogTitle: 'मुफ्त ऑनलाइन टाइमर - अध्ययन और काम ब्रेक के लिए आदर्श',
        ogDescription: '⏰ ध्वनि सतर्कता के साथ कस्टम काउंटडाउन टाइमर सेट करें। पोमोडोरो तकनीक, अध्ययन सत्र और उत्पादकता के लिए आदर्श। कोई साइन अप की आवश्यकता नहीं!',
        ogUrl: 'https://timer.today/timer',

        // ट्विटर अनुकूलन
        twitterTitle: 'मुफ्त ऑनलाइन टाइमर - अपनी उत्पादकता बढ़ाएं',
        twitterDescription: '⏰ ध्वनि सतर्कता के साथ कस्टम काउंटडाउन टाइमर। पोमोडोरो, अध्ययन ब्रेक और समय प्रबंधन के लिए आदर्श। अभी शुरू करें!',
        twitterCard: 'summary_large_image',

        // संरचित डेटा अनुकूलन
        jsonLd:
            {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": "ऑनलाइन टाइमर - मुफ्त काउंटडाउन टूल",
                "description": "मुफ्त ऑनलाइन काउंटडाउन टाइमर कस्टम समय सेटिंग्स, ध्वनि सतर्कता और पूर्वनिर्धारित विकल्प के साथ। उत्पादकता और समय प्रबंधन के लिए आदर्श।",
                "url": "https://timer.today/timer",
                "applicationCategory": "Productivity",
                "operatingSystem": "Any",
                "browserRequirements": "Requires JavaScript",
                "offers": {
                    "@type": "Offer",
                    "price": "0",
                    "priceCurrency": "USD",
                    "availability": "https://schema.org/InStock"
                },
                "features": [
                    {
                        "@type": "WebPage",
                        "name": "1 मिनट टाइमर",
                        "url": "https://timer.today/timer/1-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "3 मिनट टाइमर",
                        "url": "https://timer.today/timer/3-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "5 मिनट टाइमर",
                        "url": "https://timer.today/timer/5-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "10 मिनट टाइमर",
                        "url": "https://timer.today/timer/10-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "15 मिनट टाइमर",
                        "url": "https://timer.today/timer/15-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "30 मिनट टाइमर",
                        "url": "https://timer.today/timer/30-minute-timer"
                    }
                ],
                "isAccessibleForFree": true,
                "publisher": {
                    "@type": "Organization",
                    "name": "Timer.Today",
                    "url": "https://timer.today"
                },
                "potentialAction": {
                    "@type": "UseAction",
                    "target": "https://timer.today/timer",
                    "name": "टाइमर शुरू करें"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.8",
                    "ratingCount": "70",
                    "bestRating": "5"
                }
            }
    },

    // Stopwatch page
    stopwatch: {
        title: 'ऑनलाइन स्टॉपवॉच • मिलीसेकंड के साथ उच्च सटीक टाइमर',

        description: '⏱️ पेशेवर ऑनलाइन स्टॉपवॉच मिलीसेकंड सटीकता के साथ। खेल प्रशिक्षण, फिटनेस वर्कआउट, खाना पकाने और अध्ययन टाइमिंग के लिए आदर्श। मुफ्त + सटीक! 🎯',

        keywords: [
            'ऑनलाइन स्टॉपवॉच', 'सटीक स्टॉपवॉच', 'मिलीसेकंड टाइमर',
            'डिजिटल स्टॉपवॉच', 'मुफ्त स्टॉपवॉच', 'सटीक स्टॉपवॉच',
            'मिलीसेकंड के साथ स्टॉपवॉच', 'उच्च सटीक टाइमर',
            'व्यावहारिक स्टॉपवॉच', 'लैप टाइमर', 'विभाजन टाइमर',
            'खेल टाइमर', 'प्रशिक्षण स्टॉपवॉच', 'फिटनेस टाइमर',
            'खाना पकाने वाला स्टॉपवॉच', 'वर्कआउट टाइमर', 'दौड़ने वाला स्टॉपवॉच',
            'अध्ययन टाइमर', 'अंतराल टाइमर', 'दौड़ स्टॉपवॉच'
        ],

        // सोशल मीडिया अनुकूलन
        ogTitle: 'मुफ्त ऑनलाइन स्टॉपवॉच - मिलीसेकंड सटीक टाइमर',
        ogDescription: '⏱️ खेल, फिटनेस, खाना पकाने और प्रशिक्षण के लिए सटीक टाइमिंग के साथ व्यावहारिक स्टॉपवॉच। मिलीसेकंड सटीकता, लैप समय और विभाजन समय। अभी शुरू करें!',
        ogUrl: 'https://timer.today/stopwatch',

        // ट्विटर अनुकूलन
        twitterTitle: 'सटीक ऑनलाइन स्टॉपवॉच - खेल और प्रशिक्षण के लिए आदर्श',
        twitterDescription: '⏱️ मिलीसेकंड सटीकता के साथ उच्च सटीक स्टॉपवॉच। एथलीटों, कोचों और सटीक टाइमिंग की आवश्यकता वाले किसी के लिए आदर्श।',
        twitterCard: 'summary_large_image',

        // संरचित डेटा अनुकूलन
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "ऑनलाइन स्टॉपवॉच - उच्च सटीक टाइमर",
            "description": "पेशेवर ऑनलाइन स्टॉपवॉच मिलीसेकंड सटीकता के साथ। खेल प्रशिक्षण, फिटनेस वर्कआउट, खाना पकाने टाइमिंग और सटीक समय मापन के लिए आदर्श।",
            "url": "https://timer.today/stopwatch",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",

            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
            },

            "featureList": [
                "मिलीसेकंड सटीकता टाइमिंग",
                "शुरू करें, बंद करें, रीसेट नियंत्रण",
                "पूर्ण स्क्रीन",
                "ध्वनि अधिसूचनाएं",
                "कोई विज्ञापन नहीं"
            ],

            "isAccessibleForFree": true,

            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },

            "relatedLink": [
                "https://timer.today/timer",
                "https://timer.today/worldclock"
            ],

            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.7",
                "ratingCount": "89",
                "bestRating": "5"
            }
        }
    },

    // World Clock page
    worldclock: {
        title: 'विश्व घड़ी • लाइव वैश्विक समय क्षेत्र और वर्तमान समय',

        description: '🌍 लाइव विश्व घड़ी जो विश्वभर में 200+ शहरों में वर्तमान समय दिखाती है। वास्तविक समय समय क्षेत्र, मीटिंग प्लानर और समय क्षेत्र परिवर्तक। मुफ्त और सटीक! ⏰',

        keywords: [
            'विश्व घड़ी', 'वैश्विक समय क्षेत्र', 'अभी समय', 'समय क्षेत्र परिवर्तक',
            'भारत में समय', 'न्यूयॉर्क समय', 'वैश्विक सम्मेलन समय',
            'लाइव विश्व घड़ी', 'वास्तविक समय विश्व घड़ी', 'वर्तमान विश्व समय',
            'यूएसए समय क्षेत्र', 'यूरोप समय क्षेत्र', 'एशिया समय क्षेत्र',
            'न्यूयॉर्क समय', 'लंदन समय', 'टोक्यो समय', 'सिडनी समय',
            'विश्वभर में अभी कौन सा समय है', 'अंतर्राष्ट्रीय समय तुलना'
        ],

        // सोशल मीडिया अनुकूलन
        ogTitle: 'लाइव विश्व घड़ी - 200+ वैश्विक शहरों में वर्तमान समय',
        ogDescription: '🌍 विश्वभर में वर्तमान समय तुरंत जांचें! अंतर्राष्ट्रीय व्यावसायिक बैठकों, यात्रा योजना और वैश्विक रूप से जुड़े रहने के लिए आदर्श। मुफ्त लाइव अपडेट!',
        ogImage: 'https://timer.today/images/worldclock-social-preview.jpg',
        ogUrl: 'https://timer.today/worldclock',

        // ट्विटर अनुकूलन
        twitterTitle: 'विश्व घड़ी - वैश्विक बैठक के समय को कभी न भूलें',
        twitterDescription: '🌍 200+ शहरों के साथ लाइव विश्व घड़ी। अंतर्राष्ट्रीय व्यावसायिक, यात्रा और वैश्विक समन्वय के लिए आदर्श। वास्तविक समय अपडेट!',
        twitterCard: 'summary_large_image',

        // संरचित डेटा अनुकूलन
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "विश्व घड़ी - लाइव वैश्विक समय क्षेत्र",
            "description": "वास्तविक समय विश्व घड़ी जो विश्वभर के 200+ प्रमुख शहरों में वर्तमान समय प्रदर्शित करती है। अंतर्राष्ट्रीय व्यावसायिक, यात्रा योजना और वैश्विक समन्वय के लिए आदर्श।",
            "url": "https://timer.today/worldclock",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",

            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
            },

            "featureList": [
                "200+ शहरों के लिए लाइव समय प्रदर्शन",
                "वास्तविक समय समय क्षेत्र अपडेट",
                "कई समय क्षेत्र तुलना",
                "पसंदीदा शहरों को बुकमार्क करें",
                "पूर्ण स्क्रीन"
            ],

            "serviceArea": [
                {"@type": "Place", "name": "उत्तर अमेरिका"},
                {"@type": "Place", "name": "यूरोप"},
                {"@type": "Place", "name": "एशिया प्रशांत"},
                {"@type": "Place", "name": "मध्य पूर्व"},
                {"@type": "Place", "name": "अफ्रीका"},
                {"@type": "Place", "name": "ओशिनिया"},
                {"@type": "Place", "name": "विश्वव्यापी"}
            ],

            "isAccessibleForFree": true,

            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            }
        }
    },

    // Not Found page
    notfound: {
        title: 'पृष्ठ नहीं मिला - timer.today',
        description: 'क्षमा करें, आप जो पृष्ठ ढूंढ रहे हैं वह मौजूद नहीं है। हमारे होमपेज पर वापस जाएं और हमारे ऑनलाइन टाइमर, स्टॉपवॉच और विश्व घड़ी उपकरण का उपयोग करें।',
        keywords: ['404', 'पृष्ठ नहीं मिला', 'टाइमर उपकरण'],
        ogTitle: 'पृष्ठ नहीं मिला - timer.today',
        ogDescription: 'आप जो पृष्ठ ढूंढ रहे हैं वह मौजूद नहीं है'
    },

    // Terms page
    terms: {
        title: 'सेवा की शर्तें - timer.today',
        description: 'Timer.today ऑनलाइन टाइमिंग उपकरण प्लेटफॉर्म के लिए सेवा की शर्तें और उपयोग समझौता। हमारी सेवा नियम, उपयोगकर्ता अधिकार और जिम्मेदारियों के बारे में जानें।',
        keywords: ['सेवा की शर्तें', 'उपयोगकर्ता समझौता', 'टाइमर उपकरण शर्तें'],
        ogTitle: 'सेवा की शर्तें - timer.today',
        ogDescription: 'Timer.today ऑनलाइन टाइमिंग उपकरण प्लेटफॉर्म के लिए सेवा की शर्तें और उपयोग समझौता',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "सेवा की शर्तें",
            "description": "Timer.today ऑनलाइन टाइमिंग उपकरण प्लेटफॉर्म के लिए सेवा की शर्तें और उपयोग समझौता"
        }
    },

    // Dynamic timer pages (1min, 3min, etc.)
    timerMinutes: (minutesNum: number) => {
        const useCases = {
            1: 'आंखों की आराम के ब्रेक, त्वरित ध्यान, चाय बनाना',
            3: 'अंडा उबालना, कॉफी बनाना, छोटे ब्रेक',
            5: 'ध्यान अभ्यास, नरम उबले अंडे, त्वरित वर्कआउट',
            10: 'अध्ययन ब्रेक, फोन कॉल, पढ़ने के सत्र',
            15: 'पोमोडोरो कार्य सत्र, मध्यम वर्कआउट, गहन सीखना',
            20: 'केंद्रित कार्य अवधि, फिटनेस व्यायाम, कौशल प्रशिक्षण',
            25: 'मानक पोमोडोरो तकनीक, गहन कार्य, व्यावसायिक अध्ययन',
            30: 'लंबी फोकस अवधि, वर्कआउट दिनचर्या, गहन सीखना',
            45: 'गहरी कार्य अवधि, भाषण अभ्यास, व्यावसायिक प्रशिक्षण',
            60: 'कार्य समय ब्लॉक, पाठ्यक्रम सीखना, विस्तारित वर्कआउट'
        }[minutesNum] || 'उत्पादकता और समय प्रबंधन';

        return {
            title: `${minutesNum} मिनट का टाइमर - उत्पादकता के लिए ऑनलाइन काउंटडाउन टाइमर`,
            description: `मुफ्त ${minutesNum}-मिनट काउंटडाउन टाइमर ${useCases} के लिए आदर्श। ध्वनि सतर्कता, पूर्ण स्क्रीन मोड और कस्टम सेटिंग्स की सुविधाएं। अभी अपना ${minutesNum}-मिनट का टाइमर शुरू करें!`,
            keywords: [`${minutesNum} मिनट का टाइमर`, `${minutesNum}मिन टाइमर`, 'काउंटडाउन टाइमर', 'उत्पादकता टाइमर', useCases.split(', ')[0], useCases.split(', ')[1]],
            ogTitle: `${minutesNum} मिनट का टाइमर - timer.today`,
            ogDescription: `${minutesNum}-मिनट काउंटडाउन टाइमर ध्वनि सतर्कता और डेस्कटॉप अधिसूचनाओं के साथ, ${useCases} के लिए आदर्श`,
            jsonLd: {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": `${minutesNum} मिनट का टाइमर`,
                "description": `${minutesNum}-मिनट काउंटडाउन टाइमर ध्वनि सतर्कता और डेस्कटॉप अधिसूचनाओं के साथ, ${useCases} के लिए आदर्श`,
                "applicationCategory": "Productivity"
            }
        };
    },

    // Dynamic city pages
    city: ({ cityName, countryName, timezone }: { cityName: string, countryName: string, timezone: string }) => ({
        title: `${cityName} में वर्तमान समय - लाइव ${cityName} समय और समय क्षेत्र`,
        description: `🌍 ${cityName}, ${countryName} में अभी कौन सा समय है? वर्तमान स्थानीय समय, समय क्षेत्र (${timezone}), यूटीसी ऑफसेट और तारीख जांचें। बैठकें और अंतर्राष्ट्रीय कॉल शेड्यूल करने के लिए आदर्श। मुफ्त लाइव अपडेट!`,
        keywords: [
            `${cityName} में समय`,
            `${cityName} समय`,
            `वर्तमान समय ${cityName}`,
            `${cityName} समय क्षेत्र`,
            `${cityName} घड़ी`,
            `${cityName} में अभी कौन सा समय है`,
            `${cityName} स्थानीय समय`,
            `समय क्षेत्र ${cityName}`,
            `${cityName} ${countryName} समय`,
            'विश्व घड़ी',
            'अंतर्राष्ट्रीय समय'
        ],
        ogTitle: `${cityName}, ${countryName} में वर्तमान समय - लाइव घड़ी`,
        ogDescription: `${cityName} (${timezone}) में वर्तमान समय जांचें। समय क्षेत्र जानकारी के साथ वास्तविक समय अपडेट और तारीख। अंतर्राष्ट्रीय शेड्यूलिंग के लिए आदर्श।`,
        ogUrl: `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `${cityName} में वर्तमान समय`,
            "description": `${cityName}, ${countryName} में वर्तमान स्थानीय समय समय क्षेत्र ${timezone} के साथ`,
            "url": `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
            "isPartOf": {
                "@type": "WebSite",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "about": {
                "@type": "Place",
                "name": cityName,
                "address": {
                    "@type": "PostalAddress",
                    "addressCountry": countryName
                }
            },
            "mainEntity": {
                "@type": "ClockInfo",
                "name": `${cityName} समय`,
                "timezone": timezone
            }
        }
    }),

    // Timestamp converter page
    timestamp: {
        title: 'यूनिक्स टाइमस्टैम्प परिवर्तक - एपोक समय से तारीख और कोड स्निपेट | timer.today',
        description: 'मुफ्त ऑनलाइन यूनिक्स टाइमस्टैम्प परिवर्तक। एपोक समय को तारीख में और इसके विपरीत परिवर्तित करें। पायथन, जावा, MySQL, जावास्क्रिप्ट और PHP के लिए टाइमस्टैम्प चीट शीट शामिल है।',
        keywords: [
            'टाइमस्टैम्प परिवर्तक',
            'यूनिक्स टाइमस्टैम्प',
            'एपोक समय परिवर्तक',
            'टाइमस्टैम्प को तारीख में',
            'तारीख को टाइमस्टैम्प में',
            'यूनिक्स समय परिवर्तक',
            'पायथन टाइमस्टैम्प',
            'जावा टाइमस्टैम्प',
            'MySQL टाइमस्टैम्प',
            'जावास्क्रिप्ट टाइमस्टैम्प',
            'PHP टाइमस्टैम्प',
            'ISO 8601',
            'वर्तमान एपोक समय',
            'टाइमस्टैम्प चीट शीट'
        ],
        ogTitle: 'यूनिक्स टाइमस्टैम्प परिवर्तक और एपोक समय टूल',
        ogDescription: 'एपोक समय को तारीख में परिवर्तित करें पायथन, जावा, MySQL, जावास्क्रिप्ट और PHP के कोड उदाहरणों के साथ। मुफ्त ऑनलाइन टाइमस्टैम्प परिवर्तक।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "यूनिक्स टाइमस्टैम्प परिवर्तक",
            "description": "पायथन, जावा, MySQL, जावास्क्रिप्ट और PHP के कोड स्निपेट के साथ मुफ्त ऑनलाइन यूनिक्स टाइमस्टैम्प परिवर्तक",
            "url": "https://timer.today/timestamp",
            "applicationCategory": "DeveloperApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "यूनिक्स टाइमस्टैम्प से तारीख परिवर्तन",
                "तारीख से टाइमस्टैम्प परिवर्तन",
                "वर्तमान एपोक समय प्रदर्शन",
                "पायथन, जावा, MySQL, जावास्क्रिप्ट, PHP के लिए कोड उदाहरण",
                "सेकंड और मिलीसेकंड प्रारूप सहायता",
                "ISO 8601 प्रारूप आउटपुट"
            ]
        }
    },

    // YouTube Timestamp Link Generator
    youtubeLink: {
        title: 'YouTube टाइमस्टैम्प लिंक जनरेटर - साझा करने योग्य वीडियो लिंक बनाएं | timer.today',
        description: '📺 विशिष्ट समय पर शुरू होने वाले YouTube लिंक बनाएं। सोशल मीडिया, ईमेल और फोरम पर वीडियो पल साझा करने के लिए आदर्श। सभी YouTube वीडियो के साथ काम करता है!',
        keywords: [
            'YouTube टाइमस्टैम्प लिंक',
            'YouTube टाइमस्टैम्प',
            'YouTube लिंक टाइमस्टैम्प के साथ',
            'YouTube लिंक विशिष्ट समय पर',
            'YouTube साझा टाइमस्टैम्प',
            'YouTube टाइमस्टैम्प यूआरएल',
            'YouTube शुरुआत समय लिंक',
            'YouTube वीडियो टाइमस्टैम्प',
            'YouTube टाइमस्टैम्प जनरेटर',
            'YouTube लिंक जनरेटर',
            'YouTube एम्बेड टाइमस्टैम्प'
        ],
        ogTitle: 'YouTube टाइमस्टैम्प लिंक जनरेटर - सटीक क्षणों पर वीडियो साझा करें',
        ogDescription: 'YouTube लिंक बनाएं जो किसी भी समय पर शुरू हों। सोशल मीडिया, ईमेल और एम्बेड कोड के लिए टाइमस्टैम्प के साथ साझा करने योग्य यूआरएल बनाएं।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "YouTube टाइमस्टैम्प लिंक जनरेटर",
            "description": "विशिष्ट वीडियो पलों को साझा करने के लिए टाइमस्टैम्प के साथ YouTube लिंक बनाएं",
            "url": "https://timer.today/youtube-timestamp-link",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "छोटे और पूर्ण YouTube लिंक बनाएं",
                "टाइमस्टैम्प के साथ एम्बेड कोड बनाएं",
                "लाइव वीडियो प्रीव्यू",
                "कई URL प्रारूप समर्थन",
                "एक क्लिक कॉपी"
            ]
        }
    },

    // YouTube Timestamp Generator (for chapters/comments)
    youtubeGenerator: {
        title: 'YouTube टाइमस्टैम्प जनरेटर - वीडियो अध्याय और टिप्पणी बनाएं | timer.today',
        description: '🎬 वीडियो विवरण और टिप्पणियों के लिए YouTube टाइमस्टैम्प बनाएं। अध्याय बनाएं, सेकंड को टाइमस्टैम्प में परिवर्तित करें और वीडियो SEO में सुधार करें। मुफ्त उपकरण!',
        keywords: [
            'YouTube टाइमस्टैम्प जनरेटर',
            'YouTube टाइमस्टैम्प',
            'YouTube अध्याय',
            'YouTube वीडियो अध्याय',
            'YouTube टाइमस्टैम्प टिप्पणी',
            'YouTube टाइमस्टैम्प प्रारूप',
            'YouTube अध्याय जनरेटर',
            'YouTube टाइमस्टैम्प परिवर्तक',
            'YouTube विवरण टाइमस्टैम्प',
            'YouTube वीडियो टाइमस्टैम्प',
            'YouTube अध्याय कैसे जोड़ें'
        ],
        ogTitle: 'YouTube टाइमस्टैम्प जनरेटर - अध्याय और टिप्पणी बनाएं',
        ogDescription: 'YouTube वीडियो विवरण और टिप्पणियों के लिए प्रारूपित टाइमस्टैम्प बनाएं। दर्शक अनुभव और SEO में सुधार के लिए अध्याय बनाएं।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "YouTube टाइमस्टैम्प जनरेटर",
            "description": "वीडियो अध्याय, विवरण और टिप्पणियों के लिए YouTube टाइमस्टैम्प बनाएं",
            "url": "https://timer.today/youtube-timestamp-generator",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "वीडियो अध्याय जनरेटर",
                "सेकंड से टाइमस्टैम्प परिवर्तक",
                "टिप्पणी टाइमस्टैम्प टेम्पलेट",
                "बैच परिवर्तन",
                "प्रारूप सत्यापन"
            ]
        }
    },

    // MySQL Timestamp Page
    mysqlTimestamp: {
        title: 'MySQL टाइमस्टैम्प ट्यूटोरियल - UNIX_TIMESTAMP और FROM_UNIXTIME गाइड | timer.today',
        description: '📘 संपूर्ण MySQL टाइमस्टैम्प गाइड। UNIX_TIMESTAMP(), FROM_UNIXTIME(), TIMESTAMP बनाम DATETIME, समय क्षेत्र हैंडलिंग और व्यावहारिक SQL उदाहरणों के साथ प्रदर्शन अनुकूलन सीखें।',
        keywords: [
            'MySQL टाइमस्टैम्प',
            'MySQL unix_timestamp',
            'MySQL from_unixtime',
            'MySQL टाइमस्टैम्प से तारीख',
            'MySQL तारीख से टाइमस्टैम्प',
            'MySQL टाइमस्टैम्प प्रारूप',
            'MySQL टाइमस्टैम्प बनाम datetime',
            'MySQL टाइमस्टैम्प समय क्षेत्र',
            'MySQL वर्तमान टाइमस्टैम्प',
            'MySQL टाइमस्टैम्प फ़ंक्शन',
            'MySQL एपोक समय'
        ],
        ogTitle: 'MySQL टाइमस्टैम्प ट्यूटोरियल - SQL उदाहरणों के साथ संपूर्ण गाइड',
        ogDescription: 'MySQL टाइमस्टैम्प फ़ंक्शन में महारत हासिल करें: UNIX_TIMESTAMP(), FROM_UNIXTIME(), समय क्षेत्र हैंडलिंग और प्रदर्शन सुझाव। व्यावहारिक SQL उदाहरण शामिल है।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "MySQL टाइमस्टैम्प संपूर्ण गाइड",
            "description": "MySQL टाइमस्टैम्प फ़ंक्शन और सर्वोत्तम प्रथाओं पर व्यापक ट्यूटोरियल",
            "url": "https://timer.today/mysql-timestamp",
            "author": {
                "@type": "Organization",
                "name": "Timer.Today"
            },
            "datePublished": "2024-01-04",
            "educationalLevel": "Intermediate",
            "proficiencyLevel": "Intermediate"
        }
    },

    // SQL Timestamp Page (Universal)
    sqlTimestamp: {
        title: 'SQL टाइमस्टैम्प ट्यूटोरियल - MySQL, PostgreSQL, Oracle, SQL Server | timer.today',
        description: '📘 सभी प्रमुख डेटाबेस के लिए संपूर्ण SQL टाइमस्टैम्प गाइड। MySQL UNIX_TIMESTAMP, PostgreSQL EXTRACT(EPOCH), Oracle तारीख अंकगणित और व्यावहारिक उदाहरणों के साथ SQL Server DATEDIFF_BIG में महारत हासिल करें।',
        keywords: [
            'SQL टाइमस्टैम्प',
            'MySQL टाइमस्टैम्प',
            'PostgreSQL टाइमस्टैम्प',
            'Oracle टाइमस्टैम्प',
            'SQL Server टाइमस्टैम्प',
            'SQL यूनिक्स टाइमस्टैम्प',
            'SQL टाइमस्टैम्प से तारीख',
            'SQL तारीख से टाइमस्टैम्प',
            'SQL वर्तमान टाइमस्टैम्प',
            'SQL टाइमस्टैम्प फ़ंक्शन',
            'टाइमस्टैम्प SQL',
            'SQL टाइमस्टैम्प प्रारूप',
            'SQL टाइमस्टैम्प तुलना',
            'SQL एपोक समय',
            'डेटाबेस टाइमस्टैम्प'
        ],
        ogTitle: 'SQL टाइमस्टैम्प ट्यूटोरियल - सभी प्रमुख डेटाबेस के लिए संपूर्ण गाइड',
        ogDescription: 'MySQL, PostgreSQL, Oracle और SQL Server में टाइमस्टैम्प हैंडलिंग में महारत हासिल करें। व्यावहारिक SQL उदाहरणों के साथ व्यापक गाइड और सिंटैक्स तुलना।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "सभी डेटाबेस के लिए SQL टाइमस्टैम्प संपूर्ण गाइड",
            "description": "MySQL, PostgreSQL, Oracle और SQL Server में टाइमस्टैम्प फ़ंक्शन पर व्यापक ट्यूटोरियल",
            "url": "https://timer.today/sql-timestamp",
            "author": {
                "@type": "Organization",
                "name": "Timer.Today"
            },
            "datePublished": "2025-01-05",
            "dateModified": "2025-01-05",
            "educationalLevel": "Intermediate",
            "proficiencyLevel": "Intermediate",
            "keywords": "SQL, MySQL, PostgreSQL, Oracle, SQL Server, टाइमस्टैम्प, डेटाबेस"
        }
    },

    // Python Timestamp Page
    pythonTimestamp: {
        title: 'Python टाइमस्टैम्प ट्यूटोरियल - datetime, time, calendar मॉड्यूल गाइड | timer.today',
        description: '🐍 संपूर्ण Python टाइमस्टैम्प गाइड। datetime, time और calendar मॉड्यूल में महारत हासिल करें। समय क्षेत्र हैंडलिंग, टाइमस्टैम्प परिवर्तन और व्यावहारिक कोड उदाहरण सीखें।',
        keywords: [
            'Python टाइमस्टैम्प',
            'Python टाइमस्टैम्प प्राप्त करें',
            'Python datetime टाइमस्टैम्प',
            'Python टाइमस्टैम्प से datetime',
            'Python datetime से टाइमस्टैम्प',
            'Python time टाइमस्टैम्प',
            'Python टाइमस्टैम्प से तारीख',
            'Python यूनिक्स टाइमस्टैम्प',
            'Python टाइमस्टैम्प समय क्षेत्र',
            'Python टाइमस्टैम्प मिलीसेकंड'
        ],
        ogTitle: 'Python टाइमस्टैम्प ट्यूटोरियल - datetime और time मॉड्यूल गाइड',
        ogDescription: 'datetime, time और calendar मॉड्यूल के साथ Python टाइमस्टैम्प हैंडलिंग में महारत हासिल करें। समय क्षेत्र हैंडलिंग और व्यावहारिक उदाहरण शामिल है।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "Python टाइमस्टैम्प संपूर्ण गाइड",
            "description": "datetime और time मॉड्यूल के साथ Python टाइमस्टैम्प हैंडलिंग पर व्यापक ट्यूटोरियल",
            "url": "https://timer.today/python-timestamp",
            "programmingLanguage": "Python"
        }
    },

    // JavaScript Timestamp Page
    javascriptTimestamp: {
        title: 'JavaScript टाइमस्टैम्प ट्यूटोरियल - Date ऑब्जेक्ट और मेथड्स गाइड | timer.today',
        description: '⚡ संपूर्ण JavaScript टाइमस्टैम्प गाइड। Date ऑब्जेक्ट, Date.now(), getTime(), टाइमस्टैम्प परिवर्तन और Day.js जैसी लोकप्रिय लाइब्रेरी में महारत हासिल करें।',
        keywords: [
            'JavaScript टाइमस्टैम्प',
            'js टाइमस्टैम्प',
            'JavaScript टाइमस्टैम्प प्राप्त करें',
            'JavaScript Date टाइमस्टैम्प',
            'date.now JavaScript',
            'JavaScript टाइमस्टैम्प से तारीख',
            'JavaScript तारीख से टाइमस्टैम्प',
            'JavaScript यूनिक्स टाइमस्टैम्प',
            'JavaScript टाइमस्टैम्प मिलीसेकंड',
            'JavaScript Date gettime'
        ],
        ogTitle: 'JavaScript टाइमस्टैम्प ट्यूटोरियल - Date ऑब्जेक्ट गाइड',
        ogDescription: 'JavaScript Date ऑब्जेक्ट और टाइमस्टैम्प मेथड्स में महारत हासिल करें। आधुनिक लाइब्रेरी और व्यावहारिक उदाहरण शामिल है।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "JavaScript टाइमस्टैम्प संपूर्ण गाइड",
            "description": "JavaScript Date ऑब्जेक्ट और टाइमस्टैम्प हैंडलिंग पर व्यापक ट्यूटोरियल",
            "url": "https://timer.today/javascript-timestamp",
            "programmingLanguage": "JavaScript"
        }
    },

    // Discord Timestamp Generator
    discordTimestamp: {
        title: 'Discord टाइमस्टैम्प जनरेटर - <t:format> कोड बनाएं | timer.today',
        description: '🎮 स्वचालित समय क्षेत्र परिवर्तन के साथ Discord टाइमस्टैम्प बनाएं। ईवेंट, काउंटडाउन और घोषणाओं के लिए <t:timestamp:format> कोड बनाएं। सभी Discord चैनलों में काम करता है!',
        keywords: [
            'Discord टाइमस्टैम्प',
            'Discord टाइमस्टैम्प जनरेटर',
            'Discord समय प्रारूप',
            'Discord टाइमस्टैम्प कोड',
            'Discord <t> प्रारूप',
            'Discord टाइमस्टैम्प परिवर्तक',
            'Discord गतिशील टाइमस्टैम्प',
            'Discord समय परिवर्तक',
            'Discord ईवेंट टाइमस्टैम्प',
            'Discord काउंटडाउन',
            'Discord समी क्षेत्र परिवर्तक'
        ],
        ogTitle: 'Discord टाइमस्टैम्प जनरेटर - स्वचालित समी क्षेत्र परिवर्तन',
        ogDescription: 'Discord टाइमस्टैम्प कोड बनाएं जो हर उपयोगकर्ता के स्थानीय समय क्षेत्र में स्वचालित रूप से समायोजित हो। ईवेंट, रेड और सामुदायिक शेड्यूलिंग के लिए आदर्श।',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Discord टाइमस्टैम्प जनरेटर",
            "description": "ईवेंट और घोषणाओं के लिए स्वचालित समय क्षेत्र परिवर्तन के साथ Discord टाइमस्टैम्प कोड बनाएं",
            "url": "https://timer.today/discord-timestamp-generator",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "7 Discord टाइमस्टैम्प प्रारूप",
                "स्वचालित समी क्षेत्र परिवर्तन",
                "लाइव प्रीव्यू",
                "एक क्लिक कॉपी",
                "प्रारूप संदर्भ तालिका",
                "सामान्य उपयोग केस गाइड"
            ]
        }
    },

    // Dynamic country pages
    country: ({ countryName, citiesCount }: { countryName: string, citiesCount: number }) => ({
        title: `${countryName} में समय - वर्तमान स्थानीय समय और समय क्षेत्र`,
        description: `🌍 ${countryName} में ${citiesCount}+ शहरों में वर्तमान समय जांचें। वास्तविक समय समय क्षेत्र अपडेट, यूटीसी ऑफसेट और स्थानीय समय। व्यावसायिक बैठकें और अंतर्राष्ट्रीय समन्वय के लिए आदर्श।`,
        keywords: [
            `${countryName} में समय`,
            `${countryName} समय`,
            `${countryName} समी क्षेत्र`,
            `वर्तमान समय ${countryName}`,
            `${countryName} घड़ी`,
            `${countryName} में अभी कौन सा समय है`,
            `${countryName} स्थानीय समय`,
            `${countryName} शहर समय`,
            'विश्व घड़ी',
            'अंतर्राष्ट्रीय समय'
        ],
        ogTitle: `${countryName} में वर्तमान समय - ${citiesCount}+ शहर`,
        ogDescription: `सभी प्रमुख शहरों में ${countryName} में वर्तमान समय देखें। वास्तविक समी क्षेत्र जानकारी के साथ लाइव अपडेट।`,
        ogUrl: `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `${countryName} में समय`,
            "description": `${countryName} के ${citiesCount}+ शहरों में वर्तमान स्थानीय समय`,
            "url": `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
            "isPartOf": {
                "@type": "WebSite",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "about": {
                "@type": "Place",
                "name": countryName,
                "geo": {
                    "@type": "Country",
                    "name": countryName
                }
            }
        }
    })
};
